export const CONTACT_URL = 'https://www.esri.com/en-us/contact';
export const CONTACT_DEV_URL = 'https://aem-dev.esri.com/en-us/contact';
export const CONTACT_STG_URL = 'https://uat.esri.com/en-us/contact';

export const ERROR_TYPES = {
  PURCHASE_LIMIT: 'purchase_limit_reached',
  GENERIC: 'generic',
};

export const ERROR_CODES = {
  PURCHASE_LIMIT: 1,
  MAX_QUANTITY_EXCEEDED: 2,
  ARCGIS_SCHOOL_BUNDLE_LIMIT: 11,
};

export const AEM_MAPPED_TYPES = {
  CART: 'esri-sites/components/content/cart',
  CUSTOMER_NUMBER: 'esri-sites/components/content/customer-number',
  EXPERIENCE_FRAGMENT: 'esri-sites/components/experiencefragment',
  PRODUCT_PRICING: 'esri-sites/components/content/product-pricing',
  PRODUCT_PRICING_MODAL: 'esri-sites/components/content/product-pricing-modal',
  PRODUCT_PRICING_SECTION: 'esri-sites/components/content/product-pricing-section',
  PRODUCT_PRICING_COMPARISON_TABLE: 'esri-sites/components/content/product-pricing-comparison-table',
  SEARCH_RESULTS: 'esri-sites/components/content/search-results',
};

export const AEM_MAPPED_TYPES_LIST = Object.values(AEM_MAPPED_TYPES);

// Components already mapped internally by @adobe/aem-react-editable-components
export const AEM_IGNORE_TYPES_LIST = ['wcm/foundation/components/responsivegrid'];

export const ESRI_SUBDOMAINS = new Set([
  'uat-int-store',
  'uat-ea-store',
  'uat-il-store',
  'uat-fr-store',
  'int-store',
  'ea-store',
  'il-store',
  'fr-store',
  'checkoutlocal',
  'checkoutstg',
  'checkout',
  'mydev',
  'mystg',
  'my'
]);

export const SHARED_SUBDOMAINS = new Set(['www', 'uat', 'preview', 'aem-dev']);

export const ESRI_ROOTDOMAINS = new Set(['esri.com']);

export const DISTRIBUTOR_ROOTDOMAINS = new Set([
  'aeroterra.com',
  'esri.ca',
  'esri-cis.com',
  'esri.ch',
  'esri.cl',
  'esri.co',
  'esri.com.tr',
  'esri.de',
  'esri.es',
  'esri.fi',
  'esri.ie',
  'esri-ireland.ie',
  'esri.in',
  'esri.nl',
  'esri-portugal.pt',
  'esri.ro',
  'esri.rw',
  'esri.se',
  'esrichina.hk',
  'esriuk.com',
  'gisbaltic.eu',
  'geotecnologias.com',
  'igeo.com.bo',
  'img.com.br',
  'openware.com.kw',
  'sigsa.info',
]);

export const ALL_ROOTDOMAINS = new Set([...ESRI_ROOTDOMAINS, ...DISTRIBUTOR_ROOTDOMAINS]);

export const ALLOWED_REDIRECT_HOSTNAMES = new Set([
  'author-p80902-e698666.adobeaemcloud.com',
  'author-p80902-e698666.adobeaemcloud.net',
  'author-p80902-e698665.adobeaemcloud.com',
  'author-p80902-e698665.adobeaemcloud.net',
  'author-p80902-e698709.adobeaemcloud.com',
  'author-p80902-e698709.adobeaemcloud.net',
  ...Array.from(SHARED_SUBDOMAINS).flatMap((sub) => Array.from(ALL_ROOTDOMAINS).map((root) => `${sub}.${root}`)),
  ...Array.from(ESRI_SUBDOMAINS).flatMap((sub) => Array.from(ESRI_ROOTDOMAINS).map((root) => `${sub}.${root}`)),
]);
